import { gapsOp } from 'store/ducks/Gaps';
import { GapTabs } from 'store/ducks/Gaps/types';
import { LanguageList } from 'store/ducks/globalTypes';

const gapsRequests = (
  dispatch: any,
  lang: LanguageList,
  filtersFromStorage: any
) => ({
  [GapTabs.AUDIT_FINDINGS]: () => {
    return gapsOp
      .fetchAuditFindingsMapping(lang, filtersFromStorage)
      .then((response) => {
        // Ensure response is properly formatted and avoid double wrapping
        const formattedResponse = Array.isArray(response) ? response : [];
        dispatch(gapsOp.setAuditFindingsMapping(formattedResponse));
      });
  },
  [GapTabs.EVIDENCES]: () => {
    return gapsOp
      .fetchEvidenceMapping(lang, filtersFromStorage)
      .then((response) => {
        // Ensure response is properly formatted and avoid double wrapping
        const formattedResponse = Array.isArray(response) ? response : [];
        dispatch(gapsOp.setEvidenceData(formattedResponse));
      })
      .catch((error) => {
        console.error('Error fetching evidence mapping:', error);
      });
  },
  [GapTabs.GAPS_DESC]: () => {
    return gapsOp
      .fetchGapsDescription(lang, filtersFromStorage)
      .then((response) => {
        // Ensure response is properly formatted and avoid double wrapping
        const formattedResponse = Array.isArray(response) ? response : [];

        dispatch(gapsOp.setGapsDescription(formattedResponse));
        dispatch(gapsOp.setGapsTableData(formattedResponse));
      });
  },
  [GapTabs.ADDITIONAL_INFO]: () => {
    return gapsOp
      .fetchAdditionalInfo(lang, filtersFromStorage)
      .then((response) => {
        // Ensure response is properly formatted and avoid double wrapping
        const formattedResponse = Array.isArray(response) ? response : [];

        dispatch(gapsOp.setAdditionalInfo(formattedResponse));
      });
  }
});

export default gapsRequests;
